var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { FlowCardStep } from './FlowCardStep';
export const FlowCard = (_a) => {
    var { currentIndex = undefined, ordered, className } = _a, props = __rest(_a, ["currentIndex", "ordered", "className"]);
    const { children } = props, rest = __rest(props, ["children"]);
    const childrenArray = Array.isArray(children) ? children : [children];
    const renderChildren = childrenArray.map((child, index) => {
        const hasIndex = currentIndex !== false;
        return React.cloneElement(child, {
            active: hasIndex && index === currentIndex,
            key: index,
            orderNumber: ordered && !child.props.orderNumber
                ? index + 1
                : child.props.orderNumber,
        });
    });
    return (React.createElement("div", Object.assign({ className: classnames('FlowCard', className), "data-anvil-component": "FlowCard" }, rest), renderChildren));
};
FlowCard.Step = FlowCardStep;
//# sourceMappingURL=FlowCard.js.map